"use strict";

// Uncomment import when need
// import { AppFeature, SubProp, Prop, APP_FEATURE_CATEGORY } from "@sleek-sdk/sleek-cms";

/**
 * if the feature is `existing`: (same name and category with an existing published feature)
 * - it will override its respective value and props, including enabled flag
 * - Setting props will only append new if not found and override existing if found
 * - Props merging is the same as feature merging which overrides value, enabled flag, and props if its a child prop
 * - Props can only be auto-merged from first layer; `props` of a `props` wont be overwritten
 * 
 * If the feature is `new` (name with category not published or created in cms)
 * - it will be added along with existing features
 * 
 * NOTE:
 * - App feature with `admin` category wont be added since this is running in customer app
 * - Overriding will occur in post http request or after retrieving cache or in post memoized request
 * - Override will only work if in local environment (`process.env.NODE_ENV` is `development`)
 */
export default [
  // new AppFeature({
  //   name: "testing-feature",
  //   category: APP_FEATURE_CATEGORY.CUSTOMER,
  //   enabled: true,
  //   value: {
  //     foo: "bar"
  //   },
  //   props: [
  //     new SubProp({
  //       name: "im-a-props",
  //       enabled: false,
  //       value: {
  //         foo: "bar"
  //       },
  //       props: [
  //         new Prop({
  //           name: "im-a-child-prop",
  //           enabled: true,
  //           value: {
  //             foo: "bar"
  //           }
  //         })
  //       ]
  //     })
  //   ]
  // })
];